import { FC } from "react";
import { Link } from "react-router-dom";

import CodeAttributeList from "web/Components/Common/ConfigurableDetailsList/codeAttributeList";
import ProductExpires from "web/Components/Common/ProductExpires";

import {
  CodeItemStatusCode,
  CodeItemStatusLabel,
} from "web/hooks/useCodeItemStatus/useCodeItemStatus";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { ICodeDetails, ICodeOptions } from "web/types/Code";

import classes from "./content.scss";

interface IContentProps {
  className?: string;
  link: string;
  name: string;
  expirationDate: string;
  options?: { attribute?: { wartosc?: string } }[];
  dataT1?: string;
  codeDetails?: ICodeDetails | Record<string, unknown>;
  producSuperOptions?: ICodeOptions | Record<string, unknown>;
  statusCode: CodeItemStatusCode;
  codeAttributeListSize?: number;
  label?: CodeItemStatusLabel;
}

const Content: FC<IContentProps> = ({
  className = "",
  link,
  name,
  expirationDate,
  options = [],
  dataT1 = "code_item_content",
  codeDetails = {},
  producSuperOptions = {},
  statusCode,
  codeAttributeListSize,
  label,
}) => {
  return (
    <div className={className || classes.root}>
      <h3 className={classes.title} data-t1={`${dataT1}_title`}>
        <Link
          to={link}
          title={name}
          data-t1={`${dataT1}_link`}
          data-t2={name}
          className={classes.titleLink}
        >
          {name}
        </Link>
      </h3>
      <div className={classes.content}>
        {isArrayHasItems(options) || codeAttributeListSize ? (
          <CodeAttributeList
            codeDetails={codeDetails}
            producSuperOptions={producSuperOptions}
            className={classes.codeAttributeList}
            codeAttributeListSize={codeAttributeListSize}
          />
        ) : null}
        {label ? (
          <ProductExpires
            date={expirationDate}
            dataT1={`${dataT1}_product_expires`}
            statusCode={statusCode}
            label={label as CodeItemStatusLabel}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Content;
